
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired972"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired972"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $beOXE = parcelRequire("beOXE");

var $iNA1s = parcelRequire("iNA1s");
const $66d71afb0d64e9d0$var$archiveBox = document.querySelectorAll(".archive-box");
const $66d71afb0d64e9d0$var$archiveOverlay = document.querySelector(".archive-explore-overlay");
const $66d71afb0d64e9d0$var$archiveCloseBtn = document.querySelector(".archive-explore-overlay-btn");
window.addEventListener("DOMContentLoaded", function() {
    (0, $4AGbv.gsap).registerPlugin((0, $beOXE.ScrollSmoother), (0, $iNA1s.ScrollTrigger));
    let smoother = (0, $beOXE.ScrollSmoother).create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 2,
        smoothTouch: 0.1
    });
});
$66d71afb0d64e9d0$var$archiveBox.forEach((box)=>{
    box.addEventListener("click", function(e) {
        $66d71afb0d64e9d0$var$archiveOverlay.style.display = "block";
    });
});
$66d71afb0d64e9d0$var$archiveCloseBtn.addEventListener("click", function(e) {
    $66d71afb0d64e9d0$var$archiveOverlay.style.display = "none";
    document.exitFullscreen();
});
/* ARCHIVE-SLIDER */ /** SLIDER */ const $66d71afb0d64e9d0$var$LeftClick = document.querySelector(".archive-slides-slider-left");
const $66d71afb0d64e9d0$var$RightClick = document.querySelector(".archive-slides-slider-right");
const $66d71afb0d64e9d0$var$ArchiveBox = document.querySelectorAll(".archive-box");
const $66d71afb0d64e9d0$var$sliderImages = document.querySelectorAll(".archive-slides-slider-container-image");
// SLIDER TEXT
const $66d71afb0d64e9d0$var$textSliderBoxes = document.querySelectorAll(".archive-slides-slider-text-wrapper");
const $66d71afb0d64e9d0$var$ArchiveId = function(callback) {
    $66d71afb0d64e9d0$var$ArchiveBox.forEach((box)=>{
        box.addEventListener("click", function(e) {
            callback(e.target.id);
        });
    });
};
let $66d71afb0d64e9d0$var$currentSlide = 0;
const $66d71afb0d64e9d0$var$totalSlides = $66d71afb0d64e9d0$var$sliderImages.length;
$66d71afb0d64e9d0$var$ArchiveId(function(id) {
    $66d71afb0d64e9d0$var$currentSlide = id;
    // Inisital slider position
    $66d71afb0d64e9d0$var$sliderImages.forEach((image, index)=>{
        // image.style.transform = `translateX(${index * 100}%)`;
        image.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        image.style.transition = `transform 1s ease`;
    });
    // Initial Text Position
    $66d71afb0d64e9d0$var$textSliderBoxes.forEach((text, index)=>{
        // text.style.transform = `translateX(${index * 100}%)`;
        text.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        text.style.transition = `transform 1s ease`;
    });
    if ($66d71afb0d64e9d0$var$currentSlide === 0) $66d71afb0d64e9d0$var$LeftClick.style.visibility = "hidden";
});
$66d71afb0d64e9d0$var$LeftClick.addEventListener("click", function(e) {
    console.log("left click");
    if ($66d71afb0d64e9d0$var$currentSlide > 0) $66d71afb0d64e9d0$var$currentSlide--;
    else return;
    if ($66d71afb0d64e9d0$var$currentSlide === 0) {
        $66d71afb0d64e9d0$var$LeftClick.style.visibility = "hidden";
        $66d71afb0d64e9d0$var$RightClick.style.visibility = "visible";
    }
    if ($66d71afb0d64e9d0$var$currentSlide < $66d71afb0d64e9d0$var$totalSlides - 1) $66d71afb0d64e9d0$var$RightClick.style.visibility = "visible";
    $66d71afb0d64e9d0$var$sliderImages.forEach((image, index)=>{
        image.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        image.style.transition = `transform 1s ease`;
    });
    $66d71afb0d64e9d0$var$textSliderBoxes.forEach((text, index)=>{
        text.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        text.style.transition = `transform 1s ease`;
    });
});
$66d71afb0d64e9d0$var$RightClick.addEventListener("click", function(e) {
    console.log("right click");
    if ($66d71afb0d64e9d0$var$currentSlide < $66d71afb0d64e9d0$var$totalSlides - 1) $66d71afb0d64e9d0$var$currentSlide++;
    else return;
    if ($66d71afb0d64e9d0$var$currentSlide > 0) $66d71afb0d64e9d0$var$LeftClick.style.visibility = "visible";
    if ($66d71afb0d64e9d0$var$currentSlide === $66d71afb0d64e9d0$var$totalSlides - 1) $66d71afb0d64e9d0$var$RightClick.style.visibility = "hidden";
    $66d71afb0d64e9d0$var$sliderImages.forEach((image, index)=>{
        image.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        image.style.transition = `transform 1s ease`;
    });
    $66d71afb0d64e9d0$var$textSliderBoxes.forEach((text, index)=>{
        text.style.transform = `translateX(${100 * (index - $66d71afb0d64e9d0$var$currentSlide)}%)`;
        text.style.transition = `transform 1s ease`;
    });
});
/** FULL SCREEN */ const $66d71afb0d64e9d0$var$fullScreenOpenBtn = document.querySelector(".archive-explore-fullscreen-open-btn");
const $66d71afb0d64e9d0$var$ArchiveFullScreen = document.querySelector(".archive-slides-box");
const $66d71afb0d64e9d0$var$ArchiveFullscreenTwo = document.querySelector(".archive-slides-slider-text-container");
const $66d71afb0d64e9d0$var$ArchiveFullScreenBtnBox = document.querySelector(".archive-explore-fullscreen-open-btn");
const $66d71afb0d64e9d0$var$ArchiveFullScreenCloseBtn = document.querySelector(".archive-explore-fullscreen-close-btn");
function $66d71afb0d64e9d0$var$getFullScreenElement() {
    return document.fullscreenElement;
}
function $66d71afb0d64e9d0$var$fullScreenChangeUi() {
    if ($66d71afb0d64e9d0$var$getFullScreenElement()) {
        console.log("Fullscreen ON - Element is in fullscreen mode");
        $66d71afb0d64e9d0$var$ArchiveFullScreen.classList.add("archive-slide-box-column");
        $66d71afb0d64e9d0$var$ArchiveFullscreenTwo.classList.add("archive-slide-text-contianer-remove");
        $66d71afb0d64e9d0$var$ArchiveFullScreenBtnBox.classList.add("archive-explore-fullscreen-open-btn-display-off");
        $66d71afb0d64e9d0$var$ArchiveFullScreenCloseBtn.classList.add("archive-explore-fullscreen-close-btn-on");
    } else {
        console.log("Fullscreen OFF - Element is NOT in fullscreen mode");
        $66d71afb0d64e9d0$var$ArchiveFullScreen.classList.remove("archive-slide-box-column");
        $66d71afb0d64e9d0$var$ArchiveFullscreenTwo.classList.remove("archive-slide-text-contianer-remove");
        $66d71afb0d64e9d0$var$ArchiveFullScreenBtnBox.classList.remove("archive-explore-fullscreen-open-btn-display-off");
        $66d71afb0d64e9d0$var$ArchiveFullScreenCloseBtn.classList.remove("archive-explore-fullscreen-close-btn-on");
    }
}
$66d71afb0d64e9d0$var$ArchiveFullScreenCloseBtn.addEventListener("click", function(e) {
    document.exitFullscreen();
});
document.addEventListener("fullscreenchange", $66d71afb0d64e9d0$var$fullScreenChangeUi);
$66d71afb0d64e9d0$var$fullScreenOpenBtn.addEventListener("click", function(e) {
    document.documentElement.requestFullscreen().catch((e)=>{
        console.log(e);
    });
});


//# sourceMappingURL=repo.e34f6039.js.map
